import { isMobile } from '../helpers/breakpoints';

const lockDiv = () => {
    gsap.registerPlugin(ScrollTrigger);
    // Vertical parallax effect
    gsap.utils.toArray('.lock-section').forEach(prlxItem => {
        gsap.fromTo(prlxItem.querySelector('.lock-div'),
            {
                y: -75,
            },
            {
                scrollTrigger: {
                    trigger: prlxItem,
                    start: "top bottom",
                    end: "bottom 200px",
                    scrub: true, // Give positive integer as value to get more easing/smoothness (e.g. 2,3,4)
                    markers: false, // Set to true to add markers to UI to debug.
                },
                y: 0,
                ease: "none",
                duration: 2,
            }
        );
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.lock-section') && useFadeInEffects()) {
        lockDiv();
    }
});

const useFadeInEffects = () => !!window.IntersectionObserver && !isMobile();

